import { render, staticRenderFns } from "./OriginalDocumentPoModal.vue?vue&type=template&id=c8c05f26&scoped=true"
import script from "./OriginalDocumentPoModal.vue?vue&type=script&lang=js"
export * from "./OriginalDocumentPoModal.vue?vue&type=script&lang=js"
import style0 from "./OriginalDocumentPoModal.vue?vue&type=style&index=0&id=c8c05f26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c05f26",
  null
  
)

export default component.exports